export enum CheckpointStage {
  Check = 'C',
  Customer = 'K',
  Development = 'E',
  Softline = 'S'
}
